module.exports = __webpack_public_path__ + "static/media/following.eae67554.svg";